import {Box, Container, Divider, Paper, Typography, useMediaQuery} from "@mui/material";
import aboutfoto from "../assets/aboutfoto.png"
import circularfoto from "../assets/cropped_circle_image.png"

export default function AboutMe() {
    const minWidth = useMediaQuery("(min-width:900px)");

    return (
        <Container maxWidth="md">
            <Box sx={{
                display: "flex",
                flexDirection: "column",
                flexWrap: "wrap",
                alignItems: "center",
                textAlign: "center",
                mt: 10
            }}>
                <Typography variant="h3" color={"#E39B3B"} sx={{
                    mb: 2,
                    fontFamily: 'Barlow',
                    fontSize: '40px', fontStyle: 'normal', fontWeight: '700', textTransform: "uppercase"
                }}>Over mij</Typography>
                {minWidth && <Paper sx={{display: "flex", p: 2, backgroundColor: "#FCF8F3"}}>
                    <img width="40%" src={aboutfoto} alt="picture"/>
                    <Box sx={{display: "flex", flexDirection: "column", justifyContent: "center", m: 2}}>
                        <Typography sx={{
                            fontFamily: 'Barlow',
                            fontStyle: 'normal',
                            fontWeight: '500',
                            textAlign: "center",
                            mb: 2
                        }}>
                            Hallo, ik ben Sofie, sinds 2022 baat ik mijn kleinschalig hondensalon voor grote en kleine
                            honden
                            uit. Al sinds kleins af aan heb ik een enorm groot hart voor dieren, daarom is het altijd
                            een
                            droom
                            geweest om van dieren verzorgen mijn beroep te maken.
                        </Typography>
                        <Divider color="#E39B3B" sx={{mr: 20, ml: 20, mt: 2, mb: 2}} flexItem={true} variant="middle"/>
                        <Typography sx={{
                            fontFamily: 'Barlow',
                            fontStyle: 'normal',
                            fontWeight: '500',
                            textAlign: "center",
                            mb: 2
                        }}> Na het afronden van een opleiding als zorgkundige en animator in de bejaardenzorg heb ik
                            beslist om, naast het verzorgen van ouderen mij ook toe te leggen op het verzorgen van
                            honden en
                            hiermee mijn droom na te jagen. Hiervoor heb ik een voltijdse opleiding gevolgd bij Syntra
                            te
                            Berchem waar ik mijn diploma tot hondentrimmer en pensionuitbater heb behaald. Gedurende
                            deze
                            periode heb ik zowel in het school als op stage heel wat ervaring opgedaan.</Typography>
                    </Box>
                </Paper>}
                {!minWidth && <Paper sx={{display: "flex", flexDirection: "column", alignItems: "center", p: 2, backgroundColor: "#FCF8F3"}}>
                    <img width="55%" src={circularfoto} alt="picture"/>
                    <Box sx={{display: "flex", flexDirection: "column", justifyContent: "center", m: 2}}>
                        <Typography sx={{
                            fontFamily: 'Barlow',
                            fontStyle: 'normal',
                            fontWeight: '500',
                            textAlign: "center",
                            mb: 2
                        }}>
                            Hallo, ik ben Sofie, sinds 2022 baat ik mijn kleinschalig hondensalon voor grote en kleine
                            honden
                            uit. Al sinds kleins af aan heb ik een enorm groot hart voor dieren, daarom is het altijd
                            een
                            droom
                            geweest om van dieren verzorgen mijn beroep te maken.
                        </Typography>
                        <Divider color="#E39B3B" sx={{mr: 20, ml: 20, mt: 2, mb: 2}} flexItem={true} variant="middle"/>
                        <Typography sx={{
                            fontFamily: 'Barlow',
                            fontStyle: 'normal',
                            fontWeight: '500',
                            textAlign: "center",
                            mb: 2
                        }}> Na het afronden van een opleiding als zorgkundige en animator in de bejaardenzorg heb ik
                            beslist om, naast het verzorgen van ouderen mij ook toe te leggen op het verzorgen van
                            honden en
                            hiermee mijn droom na te jagen. Hiervoor heb ik een voltijdse opleiding gevolgd bij Syntra
                            te
                            Berchem waar ik mijn diploma tot hondentrimmer en pensionuitbater heb behaald. Gedurende
                            deze
                            periode heb ik zowel in het school als op stage heel wat ervaring opgedaan.</Typography>
                    </Box>
                </Paper>}
            </Box>
        </Container>
    )
}